import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const changePasswordAction = {
    ...operations,
    ...selectors,
};

export {
    changePasswordAction,
};
export default {
    [namespace]: reducer,
};
